import { create } from 'zustand';

interface ToastAction {
  label: string;
  run: () => Promise<void> | void;
}

interface Toast {
  id: number;
  message: string;
  action?: ToastAction;
}

interface ToastState {
  toast: Toast | null;
  show: (t: Omit<Toast, 'id'>) => void;
  dismiss: () => void;
  runAction: () => Promise<void>;
}

let seq = 0;
let timer: ReturnType<typeof setTimeout> | null = null;

export const useToast = create<ToastState>((set, get) => ({
  toast: null,
  show: (t) => {
    if (timer) clearTimeout(timer);
    const id = ++seq;
    set({ toast: { ...t, id } });
    timer = setTimeout(() => {
      if (get().toast?.id === id) set({ toast: null });
    }, 5000);
  },
  dismiss: () => {
    if (timer) clearTimeout(timer);
    set({ toast: null });
  },
  runAction: async () => {
    const t = get().toast;
    if (!t?.action) return;
    if (timer) clearTimeout(timer);
    set({ toast: null });
    await t.action.run();
  },
}));
